import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { resultOf } from "../common/utilities";
/**
 * Returns only the rows that exist in the data set.
 *
 * @param {Array} - the whole data set.
 * @param {String/Function} - A function that generates a unique key for each row
 * or a string that identifies the unique key among the rows within a data set.
 * @param {Array} - Array of row ids.
 * @return {Array}
 */

export function getExistingRows(data, rowKeyFn, rows) {
  const totalRows = [];
  let i;
  const dataLength = data.length;
  const rowsLength = rows.length;

  if (rowsLength > 0) {
    /**
     * Looping through the data set in order
     * to determine whether all rows are
     * within the data set or not.
     */
    for (i = 0; i < dataLength; i++) {
      const row = data[i];
      const rowKeyValue = rowKeyFn(row);
      /**
       *  Checking if the row exists in the
       *  current data set.
       */

      if (rows.indexOf(rowKeyValue) > -1) {
        totalRows.push(rowKeyValue);
      }
      /**
       * This improves performance by limiting iterations when
       * rows are already found within the data set.
       *
       * Eg: If,
       *    data = [{id: 1}, {id: 2}, {id: 3}] and
       *    rows = [1]
       *  Since `rows` is found in the first item of the data set,
       *  we break the loop and not iterate the whole data set.
       */


      if (totalRows.length >= rowsLength) {
        break;
      }
    }
  }

  return totalRows;
}
/**
 * Returns the count of only the rows that exist in the data set.
 *
 * @param {Array} - the whole data set.
 * @param {String/Function} - A function that generates a unique key for each row
 * or a string that identifies the unique key among the rows within a data set.
 * @param {Array} - Array of row ids.
 * @return {Number}
 */

export function getExistingRowsCount() {
  return getExistingRows(...arguments).length;
}
/**
 * Returns the value to be used for the header of a column.
 *
 * @param {Object} column - the column to extract header content from.
 * @return {String|ReactElement} The value to use for the header of the supplied column.
 */

export function getColumnHeaderContent(column) {
  let headerContent;
  const {
    key,
    label,
    header
  } = column;

  if (header) {
    headerContent = resultOf(header, _objectSpread({
      key
    }, column));
  } else if (label) {
    headerContent = label;
  }

  return headerContent;
}
/**
 * Returns a unique id that describes the sortable button
 * @param {String} tableId Unique table id
 * @param {String} direction Sorting direction("none"|"asc"|"desc")
 */

export const getSortableButtonAriaDescribedById = (tableId, direction) => {
  return `${tableId}-sorted-${direction}`;
};